import * as angular from "angular";


RLScrollShadow.$inject = ["$window"];
export function RLScrollShadow($window: ng.IWindowService): ng.IDirective {
    return {
        restrict: 'A',
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
            function check() {
                if (element[0].scrollWidth > element[0].clientWidth) {
                    angular.element(element[0].parentNode).addClass("shadow");
                } else {
                    angular.element(element[0].parentNode).removeClass("shadow");
                }
            }

            angular.element($window).bind('resize', () => {
                check();
            });

            check();
        }
    }
}

